(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('resizingManagementService', ResizingManagementService);
    ResizingManagementService.$inject = [];

    function ResizingManagementService() {
        let self = this;
        self.resizing = false;
        self.currentElement = null;
        self.processing = false;
        self.allowedCursorOffset = Utils.isRetinaScreen() ? 30 : 15;
        self.resizableTags = ['img', 'table'];
        self.A4_PAGE_WIDTH = 794;
        self.DEFAULT_DPI = 96;
        self.BORDERS_WIDTH = 2;

        self.offset = (el) => {
            const rect = el.getBoundingClientRect();
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop, left: rect.left + scrollLeft, bottom: rect.bottom, right: rect.right};
        };

        self.getResizableParent = (element) => {
            if (element.classList) {
                if (element.classList.contains('editable-area')) {
                    return;
                }
                if (self.resizableTags.includes(element.nodeName.toLowerCase())) {
                    return element;
                }
            }
            return element.parentNode ? self.getResizableParent(element.parentNode) : null;
        };

        self.activateResizingTools = (elm) => {
            if (self.processing) {
                return;
            }
            self.currentElement = elm;
            self.assignResizingHandlers(elm);
            self.processing = true;
        };

        self.deactivateResizingTools = () => {
            self.processing = false;
            self.currentElement = null;
        };

        self.setSettings = (settings) => {
            self.settings = settings
        }

        self.syncModelWithView = (settings, isMarginChanged, callback) => {
            let editableArea = document.querySelector('.editable-area');
            if (!editableArea) return;

            editableArea.querySelectorAll('table').forEach(table => {
                let currentWidth = $(table).width();

                const maxWidth = self.A4_PAGE_WIDTH - ((settings.right_margin * self.DEFAULT_DPI + settings.left_margin * self.DEFAULT_DPI) + self.BORDERS_WIDTH);
                if (currentWidth && (currentWidth > maxWidth)) {
                    $(table).width(maxWidth);
                }
                if (isMarginChanged) {
                    $(table).width(maxWidth);
                }
                let defaultWidthEnabled = table.getAttribute('data-default-width') === 'true';
                const isHideBordersEnabled = table.getAttribute('data-borders') === 'true';
                self.fixTdsStyle(table, defaultWidthEnabled, isHideBordersEnabled);
            });


            self.viewModel = editableArea.innerHTML;
            let model = Utils.htmlToJson(self.viewModel);
            self.modelData = model;
            callback?.();
        };

        self.fixTdsStyle = (table, fixedWidth, isHideBordersEnabled) => {
            let tds = table.getElementsByTagName('td');
            let tableWidth = $(table).width();
            let numCols = $(table).find('tr:first-child td').length;
            let newColWidth = tableWidth / numCols;
            if (tds.length) {
                for (let i = 0; i < tds.length; i++) {
                    let width = fixedWidth ? newColWidth : ($(tds[i]).width() > 30 ? $(tds[i]).width() : 30);
                    let height = $(tds[i]).height() > 30 ? $(tds[i]).height() : 30;
                    if (fixedWidth) {
                        tds[i].style.maxWidth = width + 'px';
                        tds[i].style.height = height + 'px';
                        tds[i].style.width = width + 'px';
                    } else {
                        tds[i].style.width = width + 'px';
                        tds[i].style.height = height + 'px';
                    }
                    let existingStyle = tds[i].getAttribute('style') || '';
                    existingStyle = existingStyle.replace(/border\s*:\s*[^;]+;?/g, '');
                    if (isHideBordersEnabled) {
                        tds[i].style.border = 'none';
                    } else {
                        tds[i].style.border = '1px solid black';
                    }
                }
            }
        };

        self.getTableEditIconOffset = (elm, table) => {
            if (table) {
                let tableWidth = table?.offsetWidth;
                let offset = self.offset(elm);
                const container = document.querySelector('.content-editable-container');
                const scrolledPixels = container ? container.scrollTop : 0;
                let editableContainerOffset = $('.content-editable-container').offset() || {top: 0, left: 0}

                const editContainer = document.querySelector('.table-edit-container');
                if (editContainer) {
                    editContainer.style.display = 'block';
                    editContainer.style.zIndex = '1';
                    editContainer.style.position = 'absolute';
                    editContainer.style.cursor = 'pointer';
                    editContainer.style.height = '30px';
                    editContainer.style.top = (offset.top - editableContainerOffset.top + scrolledPixels - 17) + 'px';
                    editContainer.style.left = (offset.left - editableContainerOffset.left + tableWidth) + 'px';
                }
            }
        };

        self.isCursorInElementCorner = (e) => {
            let res = false;
            if (self.currentElement) {
                const x = e.x || e.clientX;
                const y = e.y || e.clientY;
                const elemOffset = self.offset(self.currentElement);
                const allowedOffset = self.allowedCursorOffset;
                if (
                    elemOffset.bottom + allowedOffset > y &&
                    elemOffset.bottom - allowedOffset < y &&
                    elemOffset.right + allowedOffset > x &&
                    elemOffset.right - allowedOffset < x
                ) {
                    res = true;
                }
            }
            return res;
        };

        self.getCurrentElementDimensions = () => {
            return {
                width: $(self.currentElement).width(),
                height: $(self.currentElement).height()
            };
        };

        self.assignResizingHandlers = (editorElement, callback) => {
            if ($(editorElement)) {
                $(editorElement)
                    .off('mousedown')
                    .on('mousedown', (event) => {
                        if (self.isCursorInElementCorner(event)) {
                            self.resizing = true;
                            const table = $(event.target).closest('table')[0];
                            const defaultWidthEnabled = $(table).attr('data-default-width') === 'true';
                            const isHideBordersEnabled = $(table).attr('data-borders') === 'true';
                            if (!defaultWidthEnabled && !isHideBordersEnabled) {
                                self.clearTdsStyle(table);
                            } else {
                                if (isHideBordersEnabled && !defaultWidthEnabled) {
                                    self.clearTdsStyle(table);
                                    self.setBorderStyle(table);
                                } else {
                                    self.setTdHeightStyle(table, isHideBordersEnabled);
                                }
                            }
                        }
                    })
                    .off('mouseup')
                    .on('mouseup', (event) => {
                        if (self.resizing) {
                            self.resizing = false;
                            self.syncModelWithView(this.settings, false, callback);
                        }
                    });
            }

            $(editorElement)
                .off('mouseover', self.resizableTags.join(', '))
                .on('mouseover', self.resizableTags.join(', '), (e) => {
                    if (!self.resizing) {
                        let elm = self.getResizableParent(e.target);
                        const table = $(e.target).closest('table')[0];
                        if (elm) {
                            self.activateResizingTools(elm);
                            if (table && elm.nodeName.toLowerCase() === 'table') {
                                self.activateEditIcon(e);
                            }
                        }
                        const isHideBordersEnabled = $(table).attr('data-borders') === 'true';
                        if (isHideBordersEnabled) {
                            self.addOrRemoveDashedBorders(table, isHideBordersEnabled);
                        }
                    }
                })
                .off('mouseleave', self.resizableTags.join(', '))
                .on('mouseleave', self.resizableTags.join(', '), (e) => {
                    if (!self.resizing) {
                        self.deactivateResizingTools();
                        const table = $(e.target).closest('table')[0];
                        const isHideBordersEnabled = $(table).attr('data-borders') === 'true';
                        if (isHideBordersEnabled) {
                            self.addOrRemoveDashedBorders(table, isHideBordersEnabled, true)
                        }
                        if (!self.editTableContainerLock) {
                            self.removeEditingTableIcon();
                        }
                    }
                });
        };

        self.removeEditingTableIcon = () => {
            const $editContainer = $('.table-edit-container');
            $editContainer.css({
                display: 'none'
            });
        };

        self.addOrRemoveDashedBorders = (table, isHideBordersEnabled, removeBorders) => {
            let tds = table?.getElementsByTagName('td');
            if (tds?.length) {
                for (let i = 0; i < tds.length; i++) {
                    let style = tds[i].getAttribute('style') || '';
                    style = style.replace(/border\s*:\s*[^;]+;?/g, '');
                    if (isHideBordersEnabled) {
                        if (removeBorders) {
                            style += 'border: none;';
                        } else {
                            style += 'border: 1px dashed $light-blue;';
                        }
                    }
                    tds[i].setAttribute('style', style);
                }
            }
        };

        self.clearTdsStyle = (table) => {
            let tds = table?.getElementsByTagName('td');
            if (tds && tds.length) {
                for (let i = 0; i < tds.length; i++) {
                    tds[i].removeAttribute('style');
                }
            }
        };

        self.activateEditIcon = (event) => {
            let elm = self.getResizableParent(event.target);
            if (elm.nodeName.toLowerCase() === 'table') {
                let table = event.target.closest('table');
                if (table) {
                    self.getTableEditIconOffset(elm, table);
                    self.editableTableRef = table;
                }
            }
        }

        self.setBorderStyle = (table) => {
            let tds = table?.getElementsByTagName('td');
            if (tds && tds.length) {
                for (let i = 0; i < tds.length; i++) {
                    let style = tds[i].getAttribute('style') || '';
                    style = style.replace(/border\s*:\s*[^;]+;?/g, '');
                    style += 'border:none;';
                    tds[i].setAttribute('style', style);
                }
            }
        };


        self.setTdHeightStyle = (table, isHideBordersEnabled) => {
            let tds = table?.getElementsByTagName('td');
            if (tds && tds.length) {
                for (let i = 0; i < tds.length; i++) {
                    let style = tds[i].getAttribute('style') || '';
                    style = style.replace(/height\s*:\s*[^;]+;?/g, '');
                    style += 'height:30px;';
                    if (isHideBordersEnabled) {
                        style += 'border:none;';
                    }
                    tds[i].setAttribute('style', style);
                }
            }
        };

    }
})();
